(function (angular) {
    'use strict';
    angular.module('mobilezuz').directive('spPromotion', [function () {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                product: '=',
                special: '=?',
                isHomeSpecial: '=?',
                isHomeProduct: '=?',
                isProduct: '=?',
                isSpecial: '=?',
                productSpecial: '=?',
                withoutActions: '@?',
                spTabindex:'=?',
                isCase: '=?',
            },
            templateUrl: 'views/templates/sp-promotion.html',
            controller: ['$scope', '$rootScope', '$timeout', 'Config', 'Util', 'Cart', 'SpecialDetailsDialog', function ($scope, $rootScope, $timeout, Config, Util, Cart, SpecialDetailsDialog) {

                function init(){
                    _assignSpecials();
                    $scope.promotionId = 'promotion_tooltip_' + ($scope.product ? $scope.product.id : $scope.special.id);
                    $scope.currentSpecialIndex = 0;

                    if ($scope.product && $scope.specials && $scope.specials.length) {
                        var highPrioritySpecial;
                        for (var i = 0; i < $scope.specials.length; i++) {
                            var special = $scope.specials[i];
                            if (Config.showCouponsSpecials || !special.isCoupon) {
                                var specialLoyaltyClubsCount = (special.loyaltyClubsIds && special.loyaltyClubsIds.length) || 0,
                                    topPrioritySpecialLoyaltyClubsCount = highPrioritySpecial ? (highPrioritySpecial.loyaltyClubsIds && highPrioritySpecial.loyaltyClubsIds.length) || 0 : 0;

                                if (!highPrioritySpecial || specialLoyaltyClubsCount > topPrioritySpecialLoyaltyClubsCount) {
                                    highPrioritySpecial = special;
                                } else if (topPrioritySpecialLoyaltyClubsCount === 0) {
                                    if (special.firstLevel.type < highPrioritySpecial.firstLevel.type) {
                                        highPrioritySpecial = special;
                                    }
                                }
                            }
                        }

                        $scope.specialToShow = highPrioritySpecial;
                    }

                    $scope.specialToShow = $scope.specialToShow || $scope.productSpecial || $scope.special;

                    var icons = $scope.specialToShow && $scope.specialToShow.icons;
                    var loyaltyClubsIds = $scope.specialToShow && $scope.specialToShow.loyaltyClubsIds;
                    var clubId = Array.isArray(loyaltyClubsIds) && loyaltyClubsIds.length > 0 
                        ? loyaltyClubsIds[0] 
                        : undefined;
                    var langId = $rootScope.config && $rootScope.config.language && $rootScope.config.language.id;
                    
                    $scope.specialDescription = _getSpecialDescription(icons, clubId, langId);
                }
                

                function _assignSpecials() {
                    var product = $scope.product;
                    $scope.specials = product ? Util.filterProductSpecials($scope.isCase ? product.branch.case : product.branch): [$scope.special];
                }

                $scope.$watch('product', function(){
                    init();
                });

                Util.destroyListeners($scope,  $scope.$watchGroup(['product', 'isCase'], function(newProduct, oldProduct) {
                    if (newProduct !== oldProduct) {
                        init();
                    }
                }));


                $scope.previousSpecial = function() {
                    $scope.currentSpecialIndex === 0 ? ($scope.currentSpecialIndex = $scope.specials.length - 1) : $scope.currentSpecialIndex--;
                }

                $scope.nextSpecial = function() {
                    $scope.currentSpecialIndex === $scope.specials.length - 1 ? ($scope.currentSpecialIndex = 0) : $scope.currentSpecialIndex++;
                }

                $scope.toggleTooltip = function(event) {
                    event.stopPropagation();
                    $rootScope.promotionTooltip = $scope.promotionId;
                }

                $scope.closeTooltip = function (event) {
                    event.stopPropagation();
                    $rootScope.promotionTooltip = null;

                    $timeout(function () {
                        var $button = angular.element(document.querySelector('#' + $scope.promotionId + ' .promotion-wrapper .text'));
                        $button && $button.focus();
                    });
                }

                $scope.showSpecialDetails = function(event) {
                    event.stopPropagation();
                    var showProductsFrom = Cart.specialReminders.onProducts &&
                        Cart.specialReminders.onProducts[$scope.specialToShow.id] &&
                        Cart.specialReminders.onProducts[$scope.specialToShow.id].showProductsFrom;
                    
                    // ECOM-17470 Click & Save Selected - Save to localStorage
                    $rootScope.spMixPanel.trackPreviousProperties({
                        [$rootScope.SP_SERVICES.MIXPANEL_EVENTS_LISTENERS.MIXPANEL_CLICK_SAVE_SELECTED]: {
                            specialId: $scope.specialToShow.id,
                            productId: $scope.product ? $scope.product.id : null,
                        }
                    });
                    
                    return SpecialDetailsDialog.show($scope.specialToShow.id, showProductsFrom);
                } 

                $scope.isNotEmptyObject = function(obj) {
                    return obj && Object.keys(obj).length > 0;
                };

                function _getSpecialDescription(icons, clubId, langId) {
                    if (!icons || clubId === undefined) return '';
                    return (icons[clubId] && icons[clubId][langId] && icons[clubId][langId].description) ||
                           (icons[clubId] && icons[clubId][2] && icons[clubId][2].description) ||
                           '';
                }

            }]
        };
    }]);
})(angular);